import { useQuery } from "@tanstack/react-query";

import type { ListResponse } from "@app/api/client";
import { api } from "@app/api/client";
import type { ActivityFilterType, ActivityItem } from "@app/api/types";

export interface ActivityParams {
  offset: number;
  limit: number;
  types?: ActivityFilterType[];
  organizationId?: number;
}

function buildParams(params: ActivityParams): Record<string, string | number> {
  const query: Record<string, string | number> = { offset: params.offset, limit: params.limit };
  if (params.types?.length) query.types = params.types.join(",");
  if (params.organizationId) query.organizationId = params.organizationId;
  return query;
}

export function useActivity(params: ActivityParams) {
  return useQuery({
    queryKey: ["activity", params],
    queryFn: async (): Promise<ListResponse<ActivityItem>> => {
      const { data } = await api.get<ListResponse<ActivityItem>>("/admin/activity", {
        params: buildParams(params)
      });
      return data;
    }
  });
}

export async function downloadActivityCsv(params: Omit<ActivityParams, "offset" | "limit">): Promise<void> {
  const query: Record<string, string> = {};
  if (params.types?.length) query.types = params.types.join(",");
  if (params.organizationId) query.organizationId = String(params.organizationId);

  const { data } = await api.get<Blob>("/admin/activity/export.csv", {
    params: query,
    responseType: "blob"
  });

  const url = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = url;
  link.download = "activity-export.csv";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
